import { render, staticRenderFns } from "./InternsPageTable.vue?vue&type=template&id=9ec6c074&"
import script from "./InternsPageTable.vue?vue&type=script&lang=js&"
export * from "./InternsPageTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports